const { lang: { getLangArr, LANG_ENUM } } = require('@futuweb/fego-bridge');

export const LANG = {
    SC: 'zh-cn',
    TC: 'zh-hk',
    EN: 'en-us',
    JA: 'ja',
};

export const LANG_OPTIONS = getLangArr().map((item) => {
    return {
        label: item.label,
        value: item.query
    };
}).filter((item) => {
    return item.value !== 'fr';
});

// https://gitlab.futunn.com/nodepackage/lang
export const LANG_NUM_MAP = {
    [LANG.SC]: LANG_ENUM.CN,
    [LANG.TC]: LANG_ENUM.HK,
    [LANG.EN]: LANG_ENUM.EN,
    [LANG.JA]: LANG_ENUM.JA,
};
